// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"80d66cff","183":"ad9ee05b","346":"5814c183","362":"a21538a1","602":"7b0f1ac8","782":"400a592d","820":"e46b0095","841":"89143b75","976":"6e909f10"}[chunkId] + ".chunk.js";
};